import {graphql, useStaticQuery} from "gatsby";

export const useSiteMetadataQuery = () => {
  return useStaticQuery(graphql`
     query {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `)
}


